/**
 * @generated SignedSource<<254c50d743290a24b11daaa7a884d935>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobStatus = "closed" | "deleted" | "draft" | "importing" | "opened";
import { FragmentRefs } from "relay-runtime";
export type JobPostingContent_Job$data = {
  readonly enableAutomatedMessaging: boolean | null | undefined;
  readonly firm: {
    readonly self: boolean | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly incognito: boolean | null | undefined;
  readonly jobStatus: JobStatus | null | undefined;
  readonly locationLatitude: number | null | undefined;
  readonly locationLongitude: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JobRatesFields_Job" | "JobShare_Job" | "OfficePolicyInfo_Job">;
  readonly " $fragmentType": "JobPostingContent_Job";
};
export type JobPostingContent_Job$key = {
  readonly " $data"?: JobPostingContent_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobPostingContent_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobPostingContent_Job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationLatitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationLongitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incognito",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableAutomatedMessaging",
      "storageKey": null
    },
    {
      "alias": "jobStatus",
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "self",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobRatesFields_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OfficePolicyInfo_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobShare_Job"
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "3dfc514009073de45a98238e29bddc76";

export default node;
